import { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'

import { NewsletterCheckbox } from '@/entities/assent'

import { AgreementBlock, Button, Input, LoadingCircle, RHFEmailInput } from '@/shared/ui'
import { FormSuccessMessage } from '@/shared/ui/FormSuccessMessage'

import {
	BONUS_CONVERSION_PHONE_ERROR_TEXT,
	BONUS_CONVERSION_PRELOADER_TIMEOUT_MS,
	BONUS_CONVERSION_SUCCESS_TEXT,
	BONUS_CONVERSION_TITLE
} from '../../model/constants'

import { useBonusConversionForm } from './hooks/use-bonus-conversion-form'

import cl from './bonus-conversion-form.module.scss'

type BonusConversionFormProps = {
	onClose: () => void
}

export const BonusConversionForm = ({ onClose }: BonusConversionFormProps) => {
	const [isInitialPreloaderVisible, setIsInitialPreloaderVisible] = useState(true)

	const {
		control,
		errors,
		userInfoIsLoading,
		showNewsletterCheckbox,
		isNewsletterAccepted,
		setIsNewsletterAccepted,
		submitHandler,
		onManualSubmitClick,
		isLoading,
		canSubmit,
		hasPhone,
		errorMessage,
		isSuccess,
		isAutoFlowResolved
	} = useBonusConversionForm()

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsInitialPreloaderVisible(false)
		}, BONUS_CONVERSION_PRELOADER_TIMEOUT_MS)

		return () => clearTimeout(timer)
	}, [])

	if (isInitialPreloaderVisible) {
		return (
			<div className={cl.root}>
				<h3 className={cl.title}>{BONUS_CONVERSION_TITLE}</h3>
				<div className={cl.preloader}>
					<LoadingCircle size={32} />
					<p className={cl.pending}>Проверяем данные...</p>
				</div>
			</div>
		)
	}

	if (isSuccess) {
		return (
			<FormSuccessMessage title="2000 бонусов начислены!" subtitle={BONUS_CONVERSION_SUCCESS_TEXT} onOk={onClose} />
		)
	}

	if (!isAutoFlowResolved) {
		return (
			<div className={cl.root}>
				<h3 className={cl.title}>{BONUS_CONVERSION_TITLE}</h3>
				<p className={cl.pending}>Проверяем данные...</p>
			</div>
		)
	}

	return (
		<div className={cl.root}>
			<h3 className={cl.title}>{BONUS_CONVERSION_TITLE}</h3>

			<form className={cl.form} onSubmit={submitHandler}>
				<div className={cl.formItem}>
					<Controller
						name="NAME"
						control={control}
						render={({ field }) => (
							<Input
								label="Имя"
								value={field.value}
								onChange={field.onChange}
								onBlur={field.onBlur}
								isError={!!errors.NAME}
								helperText={errors.NAME?.message}
								isLoading={userInfoIsLoading}
							/>
						)}
					/>
				</div>

				<div className={cl.formItem}>
					<RHFEmailInput
						name="EMAIL"
						control={control}
						error={errors.EMAIL}
						label="Email"
						isLoading={userInfoIsLoading}
					/>
				</div>

				{showNewsletterCheckbox && (
					<div className={cl.checkboxes}>
						<NewsletterCheckbox checked={isNewsletterAccepted} onChange={setIsNewsletterAccepted} />
					</div>
				)}

				<Button
					className={cl.submit}
					type="button"
					theme="primary"
					onClick={onManualSubmitClick}
					isLoading={isLoading}
					disabled={isLoading || !canSubmit}>
					Отправить
				</Button>

				{!!errorMessage && <p className={cl.error}>{errorMessage}</p>}
				{!hasPhone && !userInfoIsLoading && !errorMessage && (
					<p className={cl.error}>{BONUS_CONVERSION_PHONE_ERROR_TEXT}</p>
				)}

				<div className={cl.agreement}>
					<AgreementBlock />
				</div>
			</form>
		</div>
	)
}
